import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';

import { useAskAnything } from './useAskAnything';

export const AskAnythingButton = () => {
  const intl = useIntl();
  const { isChatBotVisible, handleToggleChatbot, chatbotData } =
    useAskAnything();

  return (
    <Button
      icon="evisort-ai-static"
      iconPosition="left"
      variant="cta-ai"
      size="s"
      isSelected={isChatBotVisible}
      text={intl.formatMessage({
        id: 'AskAnythingButton.text',
        defaultMessage: 'Ask AI',
        description: 'Button text to open AI chatbot',
      })}
      disabled={chatbotData.isEntityLoading}
      onClick={handleToggleChatbot}
    />
  );
};
